import React, { useEffect, useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import { useSearchParams } from "react-router-dom";
import { fetchScopeName } from "@features/admin/invitations/hooks/useInvitations";
import InvitationsTable from "@features/admin/invitations/components/InvitationsTable";
import SendInvitationModal from "@features/admin/invitations/components/SendInvitationModal";


const ManageInvitations: React.FC = () => {
    const [searchParams] = useSearchParams();
    const s = searchParams.get("s") || "";
    const sid = Number(searchParams.get("sid"));

    const [showCreate, setShowCreate] = useState(false);

    const scopeMap: Record<'c' | 'd' | 'n', string> = {
        c: "Church",
        d: "District",
        n: "Nation",
    };

    const scopeKey = s.toLowerCase() as keyof typeof scopeMap;
    const _scopeLabel = s ? scopeMap[scopeKey] || "Unknown" : null;

    const [scopeName, setScopeName] = useState<string | undefined>(undefined);

    useEffect(() => {
        let isMounted = true;
        fetchScopeName({ scope: s, scope_ref_id: sid }).then(result => {
            if (isMounted) {
                setScopeName(result?.scopeName);
            }
        });
        return () => { isMounted = false; };
    }, [s, sid]);



    return (
        <Container fluid className="py-4" data-testid="manage-invitations-container">
            <div className="d-flex flex-column flex-md-row justify-content-md-between align-items-md-center gap-3 mb-4" data-testid="manage-invitations-header-row">
                <div className="ntcog-page-title-block mb-0">
                    <h1 className="ntcog-page-heading mb-1" data-testid="manage-invitations-title">Invitations</h1>
                    <p className="text-muted mb-0" data-testid="manage-invitations-description">
                        Manage invitations{scopeName && <> for <strong data-testid="manage-invitations-scope-label">{scopeName}</strong></>}
                    </p>
                </div>
                {Number.isFinite(sid) && sid > 0 && (
                    <Button
                        variant="primary"
                        onClick={() => setShowCreate(true)}
                        aria-label="Invite User"
                        data-testid="invite-user-button"
                    >
                        <i className="bi bi-send me-2" aria-hidden="true"></i>
                        Invite User
                    </Button>
                )}
            </div>

            <InvitationsTable
                scope={s}
                scopeRefId={sid}
                showPagination={true}
                data-testid="invitations-table"
            />

            <SendInvitationModal
                show={showCreate}
                onHide={() => setShowCreate(false)}
                data-testid="send-invitation-modal"
            />
        </Container>
    );
};

export default ManageInvitations;
